import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaTransp from '../../components/leis/listar/transparencia';


function TranspScreen () {
    return (
        <Fragment>
            <Head titulo="Legislação de Transparência do Município de Macuco"/>
            <Header />
            <Container>
                <ListaTransp />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TranspScreen;